import { Accordion, AccordionDetails, AccordionSummary, FormControl, IconButton, InputAdornment, OutlinedInput } from '@mui/material';
import React, { useEffect, useState } from 'react'
import defaultImage from "../../assets/svg/defultImage.svg";
import axios from 'axios';
import { newHost } from "../../pages/Categories/CategoryProfile";
import { newImageUrl } from "../../pages/Manufacturers/ManufactureProfile"; import { useNavigate } from 'react-router';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./Engineer.css"
import { Search } from '@mui/icons-material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';

const OrdersExecuting = () => {

  const token = localStorage.getItem("token");
  const [orders, setOrders] = useState([]);
  const [expandedOrder, setExpandedOrder] = useState(null);
  const [filterDate, setFilterDate] = useState(null);

  const getOrders = async () => {
    try {
      const response = await axios.get(`${newHost}stuff/get-order-products${filterDate?`?date=${filterDate}`: ""}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const orders = response.data.data?.data


      setOrders(orders)
    }
    catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {
    getOrders()

  }, [filterDate])




  const navigte = useNavigate()

  const navigateToCheckItems = (order) => {
    navigte(`/ordersExecution/checkItems/${order.id}`,
      { state: { order } }
    )
  }

  return (
    <>
      <div className="m-4 min-vh-100">
        <div className="row g-3">
          <div className="col-12" dir="rtl">

            <LocalizationProvider

              dateAdapter={AdapterDayjs}>
              <DemoContainer

                components={["DateTimePicker'"]}

              >
                <DatePicker
                  sx={{ width: "25%" }}
                  className="m-0"
                  format="YYYY,MM,DD"
                  slotProps={{
                    textField: { size: "small", placeholder: "اختار تاريخ الطلب" },
                    field: {
                      clearable: true,
                      onClear: () => setFilterDate(""),
                    },
                  }


                  }
                  value={filterDate ? dayjs(filterDate) : null}
                  onChange={(date) =>
                    setFilterDate(date ? date.format("YYYY-MM-DD") : "")}

                />


              </DemoContainer>
            </LocalizationProvider>


            {orders.length > 0 ? [...orders].reverse().map((order) => (
              <Accordion
                key={order.id}
                expanded={expandedOrder === order.id}
                onChange={() =>
                  setExpandedOrder(expandedOrder === order.id ? null : order.id)
                }
                sx={{
                  backgroundColor: "#F9F9F9",
                  my: 2,
                  py: 1,
                  border: "none",
                  outline: "none",
                  "&:before": {
                    display: "none",
                  },
                  "&.Mui-expanded": {
                    boxShadow: "none",
                  },
                }}
                className="shadow-sm"
              >
                {/* ===== HEADER ===== */}
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <div className="row w-100 align-items-center">
                    <div className="col-12 d-flex align-items-center">
                      <div className="services-images-url">
                        <img
                          src={order.order_status?.image_url || defaultImage}
                          alt=""
                        />
                      </div>
                      <span className="fw-bold mx-2">{`ORD-#${order.id}`}</span>
                    </div>
                  </div>
                </AccordionSummary>

                {/* ===== DETAILS ===== */}
                <AccordionDetails>
                  <div className="border rounded-4 p-4">
                    <ul style={{ listStyle: "square inside" }}>
                        <li>
                        {`اسم العميل: ${
                          order.user?.name
                            ? order?.user?.name
                            : "....."
                        }`}
                      </li>
                      {/* ===== SERVICES LIST ===== */}
                      <li className="my-1">
                        الخدمات المطلوبة:
                        {order.categories?.map((item) =>
                          item?.subcategories?.map((sub) => (
                            <div
                              key={sub.id}
                              className="d-flex align-items-center gap-2 m-0"
                            >
                              <div className="services-images-url">
                                <img
                                  src={
                                    item.icon_url
                                      ? item.slug === "cover"
                                        ? item.icon_url
                                        : `${newImageUrl}${item.icon_url}`
                                      : defaultImage
                                  }
                                  alt=""
                                />
                              </div>

                              <p className="m-0">{sub.name}</p>
                            </div>
                          )),
                        )}
                      </li>

                      <li className="my-1">{`العنوان: ${order?.address?.area}`}</li>

                      <li className="my-1">{`الوقت المتوقع: ${order?.scheduled_from} - ${order?.scheduled_to}`}</li>
                      {order.discount_total > 0 ? (
                        <>
                          <li>
                            اجمالي قبل الخصم:
                            <span className="fw-bold mx-2">
                              {Number(order?.subtotal).toLocaleString("en-US")}{" "}
                              ج.م
                            </span>
                          </li>
                          <li>
                            خصم:
                            <span className="fw-bold text-danger ms-2">
                              {Number(order.discount_total).toLocaleString(
                                "en-US",
                              )}{" "}
                              ج.م
                            </span>
                          </li>
                          <li>
                            الاجمالي:
                            <span className="fw-bold mx-2">
                              {Number(order?.total).toLocaleString("en-US")} ج.م
                            </span>
                          </li>
                        </>
                      ) : (
                        <li>
                          الاجمالي:
                          <span className="fw-bold mx-2">
                            {Number(order?.total).toLocaleString("en-US")} ج.م
                          </span>
                        </li>
                      )}
                      <li className="my-1 d-flex align-items-center">
                        حالة الطلب : {order?.order_status?.label_ar}
                        <div className="services-images-url mx-2" >
                          <img

                            src={order?.order_status?.image_url || defaultImage}
                            alt=""
                          />
                        </div>

                      </li>
                    </ul>

                    {/* ===== BUTTON ===== */}
                    <div
                      className={`d-flex justify-content-center mt-3 ${order?.status == "completed" && "d-none"}`}
                    >
                      <button
                        onClick={() => navigateToCheckItems(order)}
                        className={`btn btn-dark px-5 w-50`}
                        disabled={
                          order.status !== "arrived_at_location" &&
                          order.status !== "in_progress" &&
                          order.status !== "awaiting_payment"
                        }
                      >
                        عرض الخدمات
                      </button>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
            )) : <>
              <div className="text-center py-5 text-muted">
                لا توجد طلبات مطابقة للبحث
              </div>
            </>


            }
          </div>
        </div>
      </div>
    </>
  );
}

export default OrdersExecuting